
            const data = {"name":"feather/clock","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<circle pid=\"0\" cx=\"12\" cy=\"12\" r=\"10\"/><path pid=\"1\" d=\"M12 6v6l4 2\"/>","originalColors":[],"stopColors":[]}}
        
                module.exports = data
                